<template>
<div class="apCodeUpload-page-content winner-page__hero">
   <div class="main-block position-relative">
      <div class="container-xl py-lg-5">
        <div class="row" :class="winnerType == 'heti' ? 'winner-bg--heti':''">
            <div class="col-12 pt-lg-5 custom-padding">
                <!-- mobile -->
                <!-- <div class="d-md-none winner-page__winning">
                    <img v-if="winnerType == 'napi'" src="@/assets/imgs/winnings-napi.png" alt="napi nyememény" class="img-fluid" width="350"/>
                    <img v-if="winnerType == 'heti'" src="@/assets/imgs/winnings-heti.png" width="90%" alt="heti nyeremény" class="img-fluid"/>
                    <img v-if="winnerType == 'fodij'" src="@/assets/imgs/winnings-fodij.png" class="img-fluid ">
                </div> -->

                <div class="winner-bg">
                    <div class="row">
                        <div class="col-12 col-md-5 offset-md-1 d-md-flex justify-content-center flex-column">
                            <div class="text-left winner-page--text">
                                <h1 class="text-secondary fw-900 mb-3">Gratulálunk!</h1>  
                                <p class="text-white fw-bold fs-32 mb-0">Nyereményed</p>            
                                <p class="text-white fs-22">
                                    <span class="winner-page__hero__winning" v-if="winnerType == 'napi'"><span class="">1 db piknikszett</span></span>
                                    <span class="winner-page__hero__winning " v-if="winnerType == 'heti'"><span class="">1 db 150.000 Ft értékű Decathlon utalvány</span></span>
                                    <span class="winner-page__hero__winning " v-if="winnerType == 'fodij'"><span class="">1 db All inclusive Görögországi nyaralás</span></span>
                                     <span class="winner-page__hero__winning " v-if="winnerType == 'extra'"><span class="">1 db robotfűnyíró</span></span>
                                </p>
                            </div>
                        </div>      
                        <!-- desctiop -->
                        <div class="col-12 col-md-5 position-relative winner-page__winning">
                            <img v-if="winnerType == 'napi'" src="@/assets/imgs/winner-page-napi.png" alt="napi nyememény" class="img-fluid winner-img"/>
                            <img v-if="winnerType == 'heti'" src="@/assets/imgs/winner-page-heti.png" alt="heti nyeremény" class="img-fluid winner-img"/>
                            <img v-if="winnerType == 'fodij'" src="@/assets/imgs/winner-page-fodij.png" class="img-fluid winner-img">  
                            <img v-if="winnerType == 'extra'" src="@/assets/imgs/winner-page-extra.png" class="img-fluid winner-img">                           
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- <div class="col-12 text-center text-primary order-3">
                <p style="font-size:14px;">A képek csak illusztrációk.</p>
            </div> -->
        </div>   
    </div>    
  </div>
    <div style="background: #154734;">
        <div class="col-12 col-lg-8 mx-auto text-center fs-14 fs-md-18 text-secondary py-5 d-flex flex-wrap justify-content-center align-items-center ">                                
            <p class="mb-0">A vásárlást igazoló eredeti bizonylatot sértetlen, ép állapotban 2024. augusztus 17-ig meg kell őrizni.  A képek csak illusztrációk.</p>
        </div>    
    </div>
  <!--<Ribbon/>-->
</div>
</template>

<script>
//import Ribbon from '@/components/Ribbon.vue'

export default {
    components:{
        //Ribbon
    },
    props:['winnerType']
}
</script>